var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme from 'Theme';
class BackgroundImage extends Component {
    render() {
        const _a = this.props, { image: _image, children } = _a, props = __rest(_a, ["image", "children"]);
        const image = typeof _image === 'string'
            ? _image
                ? _image.indexOf('base64') >= 0
                    ? _image
                    : process.env.REACT_APP_SERVER + _image
                : require('images/placeholder.png')
            : typeof _image === 'object' && _image instanceof ArrayBuffer ? _image
                : require('images/placeholder.png');
        return (React.createElement(Wrapper, Object.assign({}, props),
            React.createElement(Image, { image: image }, children)));
    }
}
export default BackgroundImage;
const Wrapper = cxs('div')({
    position: 'relative',
    margin: '0 auto',
    padding: Theme.size.space[2],
    overflow: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    outline: '1px solid #eee'
});
const Image = cxs('div')(({ image }) => ({
    backgroundImage: image
        ? `url(${image})`
        : `url(${require('images/placeholder.png')})`,
    width: '100%',
    paddingBottom: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain'
}));
Image.propTypes = {
    image: PropTypes.string
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/BackgroundImage.tsx
// module id = 368
// module chunks = 0